import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "left-bracket",
  "use": "left-bracket-usage",
  "viewBox": "0 0 19 30",
  "content": "<symbol viewBox=\"0 0 19 30\" xmlns=\"http://www.w3.org/2000/svg\" id=\"left-bracket\"><path d=\"M48.9998472,424 L39.9937019,424 C34.4769481,424 30,428.477148 30,433.999989 L30,444.000011 C30,449.524905 34.4743327,454 39.9937019,454 L48.9999993,454 C43.6463064,451.13749 40.0041406,445.494893 40.0041406,439 C40.0041406,432.506227 43.6456639,426.862855 48.9998472,424 Z\" transform=\"translate(-30 -424)\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/svg/left-bracket.svg
// module id = 729
// module chunks = 0